/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ResourceType } from '../models/ResourceType';

export class BackedUpByResourceTypeDataInner {
  'resourceType'?: ResourceType;
  /**
  * counter for resources backed up with EON
  */
  'eon'?: number;
  /**
  * counter for resources backed up with other cloud providers
  */
  'generalPurpose'?: number;
  /**
  * counter for resources that are not backed up
  */
  'notProtected'?: number;
  /**
  * counter for resources that are excluded from backup
  */
  'excluded'?: number;
  /**
  * counter for resources that are still in the initial classification phase
  */
  'initialClassification'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceType",
      "baseName": "resourceType",
      "type": "ResourceType",
      "format": ""
    },
    {
      "name": "eon",
      "baseName": "eon",
      "type": "number",
      "format": ""
    },
    {
      "name": "generalPurpose",
      "baseName": "generalPurpose",
      "type": "number",
      "format": ""
    },
    {
      "name": "notProtected",
      "baseName": "notProtected",
      "type": "number",
      "format": ""
    },
    {
      "name": "excluded",
      "baseName": "excluded",
      "type": "number",
      "format": ""
    },
    {
      "name": "initialClassification",
      "baseName": "initialClassification",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BackedUpByResourceTypeDataInner.attributeTypeMap;
  }

  public constructor() {
  }
}



